import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue";
import _imports_0 from '../assets/page-image/kjjlzx/banner.png';
const _hoisted_1 = {
  class: "kjjlzx-wrapper"
};
const _hoisted_2 = {
  class: "kjjlzx-page"
};
const _hoisted_3 = {
  class: "section intro-section"
};
const _hoisted_4 = {
  class: "intro-content"
};
const _hoisted_5 = {
  class: "section meeting-section"
};
const _hoisted_6 = {
  class: "meeting-cards"
};
const _hoisted_7 = {
  class: "card-image"
};
const _hoisted_8 = ["src", "alt"];
const _hoisted_9 = {
  class: "card-content"
};
const _hoisted_10 = {
  class: "card-title"
};
const _hoisted_11 = {
  class: "card-text"
};
import { onMounted, reactive } from 'vue';
import Footer from '@/components/Footer.vue';
import { getTechnologyExchangeCenterInfo } from '@/api/technology';
import { ElMessage } from 'element-plus';
export default /*@__PURE__*/_defineComponent({
  __name: 'Kjjlzx',
  setup(__props) {
    const handleApply = () => {
      ElMessage({
        message: '该功能正在建设中，敬请期待！',
        type: 'info',
        duration: 3000,
        showClose: true
      });
    };
    const centerInfo = reactive({
      descInfo: {
        key: '',
        description: ''
      },
      meetingList: []
    });
    onMounted(async () => {
      try {
        const res = await getTechnologyExchangeCenterInfo();
        if (res.data) {
          Object.assign(centerInfo, res.data);
        }
      } catch (error) {
        console.error('获取科技交流中心信息失败:', error);
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "banner-section"
      }, [_createElementVNode("img", {
        src: _imports_0,
        alt: "科技交流中心"
      })], -1)), _createElementVNode("div", _hoisted_3, [_cache[0] || (_cache[0] = _createStaticVNode("<div class=\"section-header\" data-v-133fa68c><div class=\"title-wrapper\" data-v-133fa68c><div class=\"title-box\" data-v-133fa68c>中心简介</div><div class=\"title-underline\" data-v-133fa68c></div></div><div class=\"title-line\" data-v-133fa68c></div><span class=\"more-btn\" data-v-133fa68c></span></div>", 1)), _createElementVNode("div", _hoisted_4, [_createElementVNode("p", null, _toDisplayString(centerInfo.descInfo?.description || ''), 1), _createElementVNode("div", {
        class: "intro-button"
      }, [_createElementVNode("button", {
        class: "reserve-btn",
        onClick: handleApply
      }, "预约会议")])])]), _createElementVNode("div", _hoisted_5, [_cache[1] || (_cache[1] = _createStaticVNode("<div class=\"section-header\" data-v-133fa68c><div class=\"title-wrapper\" data-v-133fa68c><div class=\"title-box\" data-v-133fa68c>会议室介绍</div><div class=\"title-underline\" data-v-133fa68c></div></div><div class=\"title-line\" data-v-133fa68c></div><span class=\"more-btn\" data-v-133fa68c></span></div>", 1)), _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(centerInfo.meetingList, (meeting, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: meeting.id,
          class: _normalizeClass(["meeting-card", index % 2 === 0 ? 'card-left' : 'card-right'])
        }, [_createElementVNode("div", _hoisted_7, [_createElementVNode("img", {
          src: meeting.image,
          alt: meeting.name
        }, null, 8, _hoisted_8)]), _createElementVNode("div", _hoisted_9, [_createElementVNode("h3", _hoisted_10, _toDisplayString(meeting.name), 1), _createElementVNode("p", _hoisted_11, _toDisplayString(meeting.introduce), 1)])], 2);
      }), 128))])])]), _createVNode(Footer)]);
    };
  }
});